import IProfileInitiativeStatus from 'types/sign-in/IProfileInitiativeStatus'

export type InitiativesSelectorDialogOpenState = 'UNDEFINED' | 'UNDEFINED_WITH_INITIATIVES' | 'OPEN' | 'CLOSED_BY_USER'

export const initiativeSelectorDialogState = {
  isDialogOpenState: 'UNDEFINED' as InitiativesSelectorDialogOpenState,
  isLoading: false,
  initiativesOptions: [] as IProfileInitiativeStatus[]
}

export type InitiativeSelectorDialogState = typeof initiativeSelectorDialogState
